import { render, staticRenderFns } from "./kdxImageVideo.g.vue?vue&type=template&id=4bd35822&scoped=true"
import script from "./kdxImageVideo.g.vue?vue&type=script&lang=js"
export * from "./kdxImageVideo.g.vue?vue&type=script&lang=js"
import style0 from "./kdxImageVideo.g.vue?vue&type=style&index=0&id=4bd35822&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd35822",
  null
  
)

export default component.exports